import { ApiPayload } from "../generic/api_types"

export type SignUpPayload = {
  user: {
    username: string,
    password: string,
    ctry_code: string,
    preferred_lang: string,
    accepted_terms: number,
    accepted_news: number
  },
  profile: {
    name: string,
    role: 'super' | 'commoner',
    birthday: string,
    avatar: {
      avatar_id: string
    }
  }
}
export type SignUpData = ApiPayload<SignUpPayload>

export enum SignUpErrorsTypes {
  UNAUTHORIZED = 401,
  BAD_REQUEST = 400
}

export enum SignUpErrorsSubtypes {
  INVALID_JSON = 171,
  MISSING_BODY = 169,
  USER_ALREADY_EXISTS = 261,
  WEAK_PASSWORD = 211
}